(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-award-2"] && !Shopify.designMode) return;
  try {
    
var about_us_award_slider = new Swiper('.lq-award-slider-section', {
    slidesPerView: 2,
    spaceBetween: 25,
    speed: 800,
    pagination: {
        el: '.lq-award-section-swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 2,          
        },
        1024: {
            slidesPerView: 2,          
        },
        1524: {
            slidesPerView: 2,        
        },
        1680: {
            slidesPerView: 2,         
        }
    }
});

var about_us_award_modal_image_slider = new Swiper('.lq-award-images-gallery', {
    slidesPerView: 4,
    spaceBetween: 20,
    speed: 800,
    pagination: {
        el: '.lq-award-model-ection-swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
        1524: {
            slidesPerView: 4,
        },
        1680: {
            slidesPerView: 4,
        }
    }
});

$('.lq-learn-more-btn').click(() => {
    $('.lq-award-modal-section').addClass('open');
    $('body').addClass('no-scroll');
});

$('.lq-award-modal-section .lq-overlay, .lq-award-modal-section .lq-award-close').click(() => {
    $('.lq-award-modal-section').removeClass('open');
    $('body').removeClass('no-scroll');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-us-award-section"] && !Shopify.designMode) return;
  try {
    
  
  var about_us_award_slider = new Swiper('.award-slider-section', {
      slidesPerView: 4,
      spaceBetween: 25,
      speed: 800,
      pagination: {
          el: '.award-section-swiper-pagination',
          clickable: true,
      },
      breakpoints: {
          // when window width is >= 320px (mobile)
          320: {
              slidesPerView: 1,
              spaceBetween: 10,
          },
          // when window width is >= 768px (tablet)
          768: {
              slidesPerView: 2,
          },
          // when window width is >= 1024px (desktop)
          1024: {
              slidesPerView: 3,
          },
          1524: {
              slidesPerView: 4,
          },
          // when window width is >= 1024px (desktop)
          1680: {
              slidesPerView: 4,
          }
      }
  });
  
  var about_us_award_modal_image_slider = new Swiper('.award-images-gallery', {
      slidesPerView: 4,
      spaceBetween: 20,
      speed: 800,
      pagination: {
          el: '.award-model-ection-swiper-pagination',
          clickable: true,
      },
      breakpoints: {
          // when window width is >= 320px (mobile)
          320: {
              slidesPerView: 1,
              spaceBetween: 10,
          },
          // when window width is >= 768px (tablet)
          768: {
              slidesPerView: 2,
          },
          // when window width is >= 1024px (desktop)
          1024: {
              slidesPerView: 3,
          },
          1524: {
              slidesPerView: 4,
          },
          // when window width is >= 1024px (desktop)
          1680: {
              slidesPerView: 4,
          }
      }
  });
  
  $('.learn-more-btn').click(() => {
    $('.award-modal-section').addClass('open');
    $('body').addClass('no-scroll');
  });
  
  $('.award-modal-section .overlay, .award-modal-section .award-close').click(() => {
    $('.award-modal-section').removeClass('open');
    $('body').removeClass('no-scroll');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-us-page-header"] && !Shopify.designMode) return;
  try {
    
    $('.page-header-section').each(function(){
        var $container = $(this); 
        $container.find('.product-header-menu .list-menu-link').click(function(){
            $('.product-header-menu .list-menu-link').removeClass('active');
            $(this).addClass('active');
            
            var targetOffset = $('.'+$(this).attr('data-scroll')).offset().top  - 50;
            $("html, body").animate({
                scrollTop: targetOffset
            }, 5);
        });
        
    });

    $(window).on('scroll', function() {
        // Get the top offset of the .page-header-section
        var productHeaderTop = $('.page-header-section').offset().top;
        var scrollPosition = $(window).scrollTop();

        // Check the scroll position
        if ($(window).scrollTop() >= productHeaderTop) {
            // Make the .page-header-section sticky
            $('.about-us-header-container').addClass('product-header-sticky');
            // Hide the header
            $('.shopify-section-header-sticky').addClass('header-hide');
        } else {
            // Remove the sticky class when scrolling above the section
            $('.about-us-header-container').removeClass('product-header-sticky');
            // Show the header again
            $('.shopify-section-header-sticky').removeClass('header-hide');
        }
        
        $(".section-scroll").each(function() {
            var sectionTop = $(this).offset().top - 100;
            var sectionBottom = sectionTop + $(this).outerHeight();
            console.log('here')
            var targetButton = $('.product-header-menu .list-menu-link[data-scroll="' + $(this).attr('class').split(' ')[1] + '"]');
            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                targetButton.addClass("active");
            } else {
                targetButton.removeClass("active");
            }

        });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-us-sustainability-section"] && !Shopify.designMode) return;
  try {
    
  
  var about_us_sustainability_slider = new Swiper('.sustainability-section-slider', {
      slidesPerView: 3,
      spaceBetween: 50,
      speed: 800,
      pagination: {
          el: '.sustainability-section-slider-swiper-pagination',
          clickable: true,
      },
      breakpoints: {
          // when window width is >= 320px (mobile)
          320: {
              slidesPerView: 1,
              spaceBetween: 20,
          },
          // when window width is >= 768px (tablet)
          768: {
              slidesPerView: 2,
              spaceBetween: 20,
          },
          // when window width is >= 1024px (desktop)
          1024: {
              slidesPerView: 3,
              spaceBetween: 20,
          },
          1524: {
              slidesPerView: 3,
              spaceBetween: 30,
          },
          // when window width is >= 1024px (desktop)
          1680: {
              slidesPerView: 3,
              spaceBetween: 40,
          }
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-us-information-section"] && !Shopify.designMode) return;
  try {
      
  
  $('.submit-btn').click(() => {
    $('.custom-modal-section').addClass('open');
    $('body').addClass('no-scroll');
  });
  
  $('.custom-modal-section .overlay, .custom-modal-section .custom-close').click(() => {
    $('.custom-modal-section').removeClass('open');
    $('body').removeClass('no-scroll');
  });

$('.custom-input-box').each(function(){
    var $container = $(this);
    var $input = $container.find('.custom-input');
    var $options = $container.find('.select-tag-option p');
    var $followUpContainer = $('.custom-input-box.follow-up');
    var $followUpInput = $followUpContainer.find('.custom-input');
    var $followUpOptions = $followUpContainer.find('.select-tag-option');

    // Define the options based on the selected service
    var optionsMapping = {
        'Product': [
            'Product quantity',
            'Product features',
            "The Product didn't meet your expectation"
        ],
        'Service': [
            'Solution Provided',
            'Procedure Efficiency',
            'Service Policy'
        ],
        'Employee': [
            'Service Attitude',
            'Professionalism',
            'Promise not Fulfilled',
            'Response Time'
        ],
        'About repair service': [
            'Repair period',
            'Repair cost',
            'Payment issue',
            'Diagnose result',
            'Multiple repairs',
            'Invoice issue',
            'Logistic issue'
        ],
        'Sales': [
            "Purchase issue",
            "Return or replacement issue",
            "Logistic issue",
            "Sales employee"
        ],
        'Others': [
            "Feedback",
            "Praise",
            "Complaint",
            "Others",
            "I will write it down in the textbox below"
        ]
    };

    // Handle click on product option
    $options.click(function(event){
        var selectedText = $(this).text();

        // Set the value and placeholder in the services-follow input
        $input.val(selectedText).attr('placeholder', selectedText);

        // Clear the visible text on focus, but retain the value
        $input.focus(function() {
            $(this).val(''); // Clear the input text when focused
        }).blur(function() {
            // If no new text is entered, restore the selected value
            if (!$(this).val()) {
                $(this).val(selectedText);
            }
        });

        // Update the follow-up options based on the selected service
        if (optionsMapping[selectedText]) {
            $followUpOptions.empty(); // Clear previous options
            optionsMapping[selectedText].forEach(function(option) {
                $followUpOptions.append('<p class="mx-0">' + option + '</p>');
            });
        } else {
            $followUpOptions.empty(); // Clear if no mapping exists
        }
    });

    // Handle click on follow-up options
    $followUpOptions.on('click', 'p', function() {
        var followUpSelectedText = $(this).text();

        // Set the value and placeholder in the follow-up input
        $followUpInput.val(followUpSelectedText).attr('placeholder', followUpSelectedText);

        // Clear the visible text on focus, but retain the value
        $followUpInput.focus(function() {
            $(this).val(''); // Clear the input text when focused
        }).blur(function() {
            // If no new text is entered, restore the selected value
            if (!$(this).val()) {
                $(this).val(followUpSelectedText);
            }
        });
    });

    // Filter options based on input value for services-follow
    $input.on('input', function() {
        var searchText = $(this).val().toLowerCase();

        // Show or hide options based on search text
        $options.each(function() {
            var optionText = $(this).text().toLowerCase();
            if (optionText.includes(searchText)) {
                $(this).show(); // Show matching option
            } else {
                $(this).hide(); // Hide non-matching option
            }
        });
    });

    // Filter options based on input value for follow-up
    $followUpInput.on('input', function() {
        var searchText = $(this).val().toLowerCase();

        // Show or hide options based on search text
        $followUpOptions.children('p').each(function() {
            var optionText = $(this).text().toLowerCase();
            if (optionText.includes(searchText)) {
                $(this).show(); // Show matching option
            } else {
                $(this).hide(); // Hide non-matching option
            }
        });
    });
});
  
$(document).ready(function() {
    // Check if the URL contains 'contact_posted=true#contact_form'
    if (window.location.href.indexOf('contact_posted=true#contact_form') !== -1) {
        $('.custom-modal-section').addClass('open');
        $('.custom-modal-container').addClass('form-success');
        $('body').addClass('no-scroll');
    }
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-icons-support"] && !Shopify.designMode) return;
  try {
    
    
    var footer_icon_support_slider = new Swiper('.footer-icon-slider', {
        slidesPerView: "auto",
        allowTouchMove: true,
        pagination: {
            el: '.footer-icon-slider-swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            // when window width is >= 320px (mobile)
            320: {
                slidesPerView: 1,
            },
            // when window width is >= 768px (tablet)
            768: {
                slidesPerView: 2,
            },
            // when window width is >= 1024px (desktop)
            1024: {
                slidesPerView: 3,
            },
            1524: {
                slidesPerView: 4,
            },
            // when window width is >= 1024px (desktop)
            1680: {
                slidesPerView: "auto",
            }
        }
        
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        $('.announcement-bar-section').addClass('active-sticky');
    
        
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        $('.announcement-bar-section').addClass('active-sticky');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        $('.announcement-bar-section').removeClass('active-sticky');
        
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  
  let headerHeight = $('.announcement-bar-section').height();
  $('.shopify-section-header-sticky').css('top', `${headerHeight - 2}px`);

$(window).resize(function() {
  let headerHeight = $('.announcement-bar-section').height();
  $('.shopify-section-header-sticky').css('top', `${headerHeight - 2}px`);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-section"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  $('.copy-link').on('click', function() {
    // Get the share link from the data attribute
    const shareLink = $(this).data('share-link');

    // Create a temporary input element to copy the link
    const tempInput = $('<input>');
    $('body').append(tempInput);
    tempInput.val(shareLink).select();
    document.execCommand('copy');
    tempInput.remove();

    // Optional: Show a confirmation message
    $('.modal-copy-link').addClass('active');
    setTimeout(function() {
      $('.modal-copy-link').removeClass('active');
    }, 2000); // 500 milliseconds = 0.5 seconds
    
  });
  $('.btn-close').on('click', function() {
    $('.modal-copy-link').removeClass('active');
  });
});


  var article_blog_list_slider = new Swiper('.mobile-blogs-slider', {
        slidesPerView: 1,
        spaceBetween: 20,
        allowTouchMove: true,
        navigation: {
            nextEl: '.mobile-blogs-button-next',
            prevEl: '.mobile-blogs-button-prev',
        },
        pagination: {
            el: '.mobile-blogs-slider-swiper-pagination',
            clickable: true,
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function actionMoreLess() {
    var boxOuter = '.data_more_less',
      boxInner = '.data_more_less_inner',
      boxBody = '.data_more_less_body',
      showMore = $('.action_more'),
      showLess = $('.action_less');

    $(boxInner).each(function () {
      var $this = $(this),
        bodyDataH = $this.find(boxBody).height();

      // Set the initial height to 80px
      $this.css('max-height', '100%');

      if (bodyDataH > 80) {
        $this.closest(boxOuter).addClass('less_active').removeClass('action_disabled');
      } else {
        $this.closest(boxOuter).addClass('action_disabled');
      }
    });

    showLess.click(function (e) {
      e.preventDefault();
      var $this = $(this);

      // Set the max-height back to 80px when 'show less' is clicked
      $this.closest(boxOuter).removeClass('less_active').find(boxInner).css('max-height', '80px');
    });

    showMore.click(function (e) {
      e.preventDefault();
      var $this = $(this);

      // Set max-height to 100% (show all content) when 'show more' is clicked
      $this.closest(boxOuter).addClass('less_active').find(boxInner).css('max-height', 'none');
    });
  }

  actionMoreLess();

  $('.support-center-section').each(function () {
    var $container = $(this);

    $container.find('.support-center-item').click(function () {
      var supportIndex = $(this).attr('support-index');
      console.log(supportIndex);
      $('.support-model').addClass('show');
      $('.support-model-content-box[support-index="' + supportIndex + '"]').addClass('active');
    });
  });
  $('.support-model.show').click(function () {
    console.log('here');
  });
  $('.support-model-content-box .support-close').click(function () {
    $('.support-model').removeClass('show');
    $('.support-model-content-box').removeClass('active');
  });

  $('.copy-discount-section').on('click', function () {
    var codeToCopy = $(this).attr('data-discount-code');
    var $tempTextarea = $('<textarea>');
    $('body').append($tempTextarea);
    $tempTextarea.val(codeToCopy).select();
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'Code copied successfully!' : 'Failed to copy code';

      alert(msg);
    } catch (err) {}

    $tempTextarea.remove();
  });

  variant_slider();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-compare-product-section"] && !Shopify.designMode) return;
  try {
    
    $('.product-detail-item').each(function(){
        var $container = $(this); 

        $container.find('ul li').click(function(){
            $container.find('ul li').removeClass('selected');
            $(this).addClass('selected');

            var variantImage = $(this).find('.color-variant-product').attr('data-variant-image');
            var variantURL = $(this).find('.color-variant-product').attr('data-variant-url');
            $container.find('.compare-product-img').attr('src', variantImage);
            $container.find('.buy-now-btn').attr('href', variantURL);
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-faqs-section"] && !Shopify.designMode) return;
  try {
    
    $('.faqs-list-container').accordion({
        heightStyle: "content",
        active: false,
        collapsible: true
    });
    $('.faqs-list-container').accordion('option', 'active', 0);


    // Initially hide all FAQ items
    $('.faqs-heading').hide();
    
    // Show only the first 4 FAQ items
    $('.faqs-heading').slice(0, 4).show();

    // Click event for the 'Load More' button
    $('.load-more-btn').on('click', function() {
        // Find hidden items and show the next 4
        var hiddenItems = $('.faqs-heading:hidden');
        hiddenItems.slice(0, 4).slideDown();
        
        // If no more items are hidden, hide the 'Load More' button
        if (hiddenItems.length <= 4) {
            $(this).hide();
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-featured-product-section"] && !Shopify.designMode) return;
  try {
    
function adjustFontSize() {
    var containerWidth = $('.featured-product-image-section').width();
    var title = $('.featured-product-title');
    var textLength = title.text().length;
    console.log(textLength);

    var baseFontSize = 23;
    var adjustedFontSize = baseFontSize;

    // Adjust font size only when text length exceeds 6 characters
    if (textLength > 6) {
        adjustedFontSize = baseFontSize - (textLength * 0.8);
    }

    adjustedFontSize = Math.max(adjustedFontSize, 2); // Ensure font size does not go below 2vw

    title.css('font-size', adjustedFontSize + 'vw');
}

adjustFontSize();

$(window).resize(function() {
    adjustFontSize();
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-featured-video-section"] && !Shopify.designMode) return;
  try {
    
    var content_slide_section = new Swiper('.content-slider-section', {
      direction: "vertical",
      slidesPerView: 1,
      speed: 800,
      creativeEffect: {
        prev: {
          translate: [0, "100%", 0],
          opacity:0,
        },
        next: {
          translate: [0, "100%", 0],
          opacity:1,
        },
      },
  });

    
  let currentFrame_video_section = 0;
  const totalFrames_video_section = 2;
  const totalSlides_video_section = content_slide_section.slides.length;
  
  $(window).scroll(() => {
      if ($(window).scrollTop() > $('.featured-video-section').offset().top) {
          currentFrame_video_section = Math.min(Math.max(
              Math.floor((($(window).scrollTop() - $('.featured-video-section').offset().top) / ($('.featured-video-section').outerHeight() - $(window).outerHeight())) * totalFrames_video_section), 0), totalFrames_video_section - 1);
          setInitialState_vidoe_section(currentFrame_video_section, totalSlides_video_section);
      }
  });
  
  setInitialState_vidoe_section(currentFrame_video_section, totalSlides_video_section);
  
  function setInitialState_vidoe_section(frame, slides) {
      content_slide_section.slideTo(Math.floor(frame / Math.ceil(totalFrames_video_section / slides)));
        console.log(Math.floor(frame / Math.ceil(totalFrames_video_section / slides)));
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-footer-section"] && !Shopify.designMode) return;
  try {
    
    $('.product-select-dropdown-container').each(function(){
        var $container = $(this); 
            
        $container.find('.default-selector').click(function(event){
            $container.addClass('show');
        });

        $container.find('.variant-list-option').click(function(event){
            $('.footer-product-add-to-cart .quick-add__submit').removeAttr('aria-disabled');
            $container.removeClass('show');
            $container.find('.product-variant-data').text($(this).text());
            $('.footer-product-id').val($(this).attr('data-variant-id'));
        });

        // Close both menus when clicking outside
        $(document).click(function(event) {
            if (!$container.is(event.target) && $container.has(event.target).length === 0) {
                $container.removeClass('show');
            }
        });
    });
$(window).on('scroll resize', function() {
    var $productFooter = $('.product-footer-section');
    var $container = $('.product-page-footer-container');

    // 容错：当前页面没有产品底部购买栏时，直接退出，避免 offset() 报错
    if (!$productFooter.length || !$container.length) {
        return;
    }

    var productFooterTop = $productFooter.offset().top;
    var windowHeight = $(window).height();
    var scrollPosition = $(window).scrollTop();

    // 兼容 DE / WWW / 默认 footer group
    var $siteFooter = $(
        '.shopify-section-group-footer-group-newde, ' +
        '.shopify-section-group-footer-group'
    ).first();

    // 容错：如果找不到 footer，就让 sticky 购买栏正常显示，不因为 JS 报错中断
    var shopifyFooterTop = $siteFooter.length ? $siteFooter.offset().top : Infinity;

    var reachedProductFooter = scrollPosition + windowHeight >= productFooterTop;
    var reachedSiteFooter = scrollPosition + windowHeight >= shopifyFooterTop;

    $container.toggleClass('product-footer-sticky', reachedProductFooter && !reachedSiteFooter);
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-header-section"] && !Shopify.designMode) return;
  try {
    
    $('.product-header-section').each(function(){
        var $container = $(this); 
        $container.find('.product-header-menu .list-menu-link').click(function(){
            $('.product-header-menu .list-menu-link').removeClass('active');
            $(this).addClass('active');
            
            var targetOffset_click = $('.'+$(this).attr('data-scroll')).offset().top  - 50;
            $("html, body").animate({
                scrollTop: targetOffset_click
            }, 5);
        });
        
    });

    $(window).on('scroll', function() {
        // Get the top offset of the .product-header-section
        var productHeaderTop = $('.product-header-section').offset().top;
        var scrollPosition = $(window).scrollTop();

        // Check the scroll position
        if ($(window).scrollTop() >= productHeaderTop) {
            // Make the .product-header-section sticky
            $('.product-header-container').addClass('product-header-sticky');
            // Hide the header
            $('.shopify-section-header-sticky').addClass('header-hide');
            $('.announcement-bar-section').addClass('header-hide');
        } else {
            // Remove the sticky class when scrolling above the section
            $('.product-header-container').removeClass('product-header-sticky');
            // Show the header again
            $('.shopify-section-header-sticky').removeClass('header-hide');
            $('.announcement-bar-section').removeClass('header-hide');
        }
        
        $(".section-scroll").each(function() {
            var sectionTop = $(this).offset().top - 100;
            var sectionBottom = sectionTop + $(this).outerHeight();

            var targetButton = $('.product-header-menu .list-menu-link[data-scroll="' + $(this).attr('class').split(' ')[1] + '"]');
            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                targetButton.addClass("active");
            } else {
                targetButton.removeClass("active");
            }

        });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-featured-product"] && !Shopify.designMode) return;
  try {
    
  $('.featured-products-section .btn-guidelines').click(() => {
    $('.featured-product-scheme-section .custom-modal-section').addClass('open');
    $('body').addClass('no-scroll');
  });
  
  $('.custom-modal-section .overlay, .custom-modal-section .custom-close').click(() => {
    $('.custom-modal-section').removeClass('open');
    $('body').removeClass('no-scroll');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-page-header-section"] && !Shopify.designMode) return;
  try {
    
    $('.promotion-header-section').each(function(){
        var $container = $(this); 
        $container.find('.product-header-menu .list-menu-link').click(function(){
            $('.product-header-menu .list-menu-link').removeClass('active');
            $(this).addClass('active');
            
            var targetOffset = $('.'+$(this).attr('data-scroll')).offset().top  - 50;
            $("html, body").animate({
                scrollTop: targetOffset
            }, 5);
        });
        
    });

    $(window).on('scroll', function() {
        // Get the top offset of the .promotion-header-section
        var productHeaderTop = $('.promotion-header-section').offset().top;
        var scrollPosition = $(window).scrollTop();

        // Check the scroll position
        if ($(window).scrollTop() >= productHeaderTop) {
            // Make the .promotion-header-section sticky
            $('.product-header-container').addClass('product-header-sticky');
            // Hide the header
            $('.shopify-section-header-sticky').addClass('header-hide');
        } else {
            // Remove the sticky class when scrolling above the section
            $('.product-header-container').removeClass('product-header-sticky');
            // Show the header again
            $('.shopify-section-header-sticky').removeClass('header-hide');
        }
        
        $(".section-scroll").each(function() {
            var sectionTop = $(this).offset().top - 100;
            var sectionBottom = sectionTop + $(this).outerHeight();
            console.log($(this).attr('class').split(' ')[0]);
            var targetButton = $('.product-header-menu .list-menu-link[data-scroll="' + $(this).attr('class').split(' ')[0] + '"]');
            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                targetButton.addClass("active");
            } else {
                targetButton.removeClass("active");
            }

        });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-review-section"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.review-slider-section', {
      grabCursor: true,
      speed: 600,
      navigation: {
          nextEl: '.review-section-button-prev',
          prevEl: '.review-section-button-next',
      },
  });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-side-product-section"] && !Shopify.designMode) return;
  try {
    
  
$(document).ready(function() {
    $('.countdown-list-container').each(function() {
        // Get the data-time-offer attribute
        var timeOffer = $(this).data('time-offer');

        // Check if the timeOffer value exists
        if (!timeOffer) {
            $(this).addClass('hide-countdown'); // Add class if no data-time-offer value
            return; // Skip further processing for this card
        }

        // Convert DD/MM/YYYY HH:MM:SS to YYYY-MM-DDTHH:MM:SS
        var parts = timeOffer.split(' '); // Split date and time
        var dateParts = parts[0].split('/'); // Split date by '/'
        var timeParts = parts[1].split(':'); // Split time by ':'

        // Construct the new date string
        var formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timeParts[0]}:${timeParts[1]}:${timeParts[2]}`;
        
        // Create a target date object
        var targetDate = new Date(formattedDate).getTime();
        console.log("Target Date:", targetDate); // Check the output

        // Update the countdown every 1 second
        var countdownInterval = setInterval(() => {
            // Get the current time
            var now = new Date().getTime();

            // Calculate the difference
            var timeDifference = targetDate - now;

            // Calculate days, hours, minutes, and seconds
            var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            // Add leading zeros if the value is less than 10
            days = days < 10 ? '0' + days : days;
            hours = hours < 10 ? '0' + hours : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;

            // Display the result in the respective HTML elements within the current card
            $(this).find('.card-day-sec').text(days);
            $(this).find('.card-hour-sec').text(hours);
            $(this).find('.card-minute-sec').text(minutes);
            $(this).find('.card-second-sec').text(seconds);

            // Check if the countdown is finished
            if (timeDifference < 0) {
                clearInterval(countdownInterval);
                $(this).find('.card-day-sec, .card-hour-sec, .card-minute-sec, .card-second-sec').text('00');
                
                // Remove class when the countdown ends
                $(this).addClass('hide-countdown'); // Add a class to hide the element
            } else {
                // Check if the current date and time equals the target date
                var currentDate = new Date();
                if (currentDate.getFullYear() === dateParts[2] && 
                    currentDate.getMonth() + 1 === parseInt(dateParts[1]) && 
                    currentDate.getDate() === parseInt(dateParts[0]) &&
                    currentDate.getHours() === parseInt(timeParts[0]) &&
                    currentDate.getMinutes() === parseInt(timeParts[1])) {
                    
                    $(this).removeClass('hide-countdown'); // Remove class if the current date matches
                }
            }
        }, 1000);
    });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qcy-product-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  const card = event.target.closest('[data-card]');
  if (!card || !event.target.closest('[data-option-index]')) return;
  const variants = JSON.parse(card.querySelector('[data-variants]').textContent);
  const selections = [...card.querySelectorAll('[data-option-index]')].map(group => group.querySelector('input:checked')?.value);
  const variant = variants.find(v => v.options.every((value, index) => value === selections[index]));
  const form = card.querySelector('form');
  const button = form.querySelector('button');
  form.querySelector('[name="id"]').value = variant ? variant.id : '';
  card.querySelectorAll('[data-price]').forEach(price => { price.hidden = !variant || price.dataset.price !== String(variant.id); });
  button.disabled = !variant || !variant.available || button.dataset.requiresPlan === 'true';
  button.textContent = button.disabled ? button.dataset.soldText : button.dataset.addText;
});
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.qcy-card__form');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button');
  if (button.disabled) return;
  const status = form.querySelector('.qcy-card__status');
  button.disabled = true;
  status.textContent = '';
  try {
    const response = await fetch(form.closest('[data-card]').dataset.cartUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || String(response.status));
    status.textContent = '✓';
    document.dispatchEvent(new CustomEvent('qcy:cart-added', { detail: result, bubbles: true }));
  } catch (error) { status.textContent = error.message; }
  finally { button.disabled = false; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qcy-sticky-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qcy-sticky-nav')) {
    customElements.define('qcy-sticky-nav', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.bar = this.querySelector('.qsn-bar');
        this.restoreButton = this.querySelector('.qsn-restore');
        this.minimized = false;
        this.previousY = Math.max(0, window.scrollY);
        this.direction = 'down';
        this.editorSelected = false; this.manuallyExpanded = false;
        this.frame = 0;
        this.refresh = () => {
          this.headers = Array.from(document.querySelectorAll('header, [role="banner"], sticky-header, #shopify-section-header, .shopify-section-group-header-group')).filter(element => !element.closest('main, [role="main"]') && !element.contains(this));
          const wrapper = this.closest('.shopify-section');
          const main = this.closest('main, [role="main"]') || document.querySelector('main, [role="main"], #MainContent');
          const scope = main || wrapper?.parentElement;
          this.sections = scope ? Array.from(scope.querySelectorAll('.shopify-section')).filter(section => {
            return !section.querySelector('qcy-sticky-nav') && !section.parentElement.closest('.shopify-section') && section.getClientRects().length && section.offsetHeight > 0;
          }) : [];
          this.querySelectorAll('[data-section-number]').forEach(button => {
            button.disabled = !this.sections[Number(button.dataset.sectionNumber) - 1];
          });
          this.schedule();
        };
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        };
        window.addEventListener('scroll', () => {
          const y = Math.max(0, window.scrollY);
          if (y !== this.previousY) {
            this.editorSelected = false; this.manuallyExpanded = false;
            this.direction = y < this.previousY ? 'up' : 'down';
          }
          this.previousY = y;
          this.schedule();
        }, { ...options, passive: true });
        window.addEventListener('wheel', event => {
          if (event.deltaY !== 0) { this.editorSelected = false; this.manuallyExpanded = false; }
          if (event.deltaY < 0) { this.direction = 'up'; this.schedule(); }
        }, { ...options, passive: true });
        window.addEventListener('touchstart', event => {
          const touch = event.touches[0];
          if (touch) { this.touchX = touch.clientX; this.touchY = touch.clientY; }
        }, { ...options, passive: true });
        window.addEventListener('touchmove', event => {
          const touch = event.touches[0];
          if (!touch || this.touchY == null) return;
          const dy = touch.clientY - this.touchY;
          const dx = touch.clientX - this.touchX;
          if (Math.abs(dy) > 3 && Math.abs(dy) > Math.abs(dx)) {
            this.editorSelected = false; this.manuallyExpanded = false;
            if (dy > 0) { this.direction = 'up'; this.schedule(); }
            this.touchX = touch.clientX;
            this.touchY = touch.clientY;
          }
        }, { ...options, passive: true });
        document.addEventListener('transitionend', this.schedule, options);
        window.addEventListener('resize', this.refresh, options);
        window.addEventListener('load', this.refresh, options);
        this.addEventListener('click', event => {
          if (event.target.closest('.qsn-minimize')) {
            this.collapseAnimation?.cancel();
            const startRect = this.bar.getBoundingClientRect();
            this.minimized = true;
            this.manuallyExpanded = false;
            this.update();
            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && startRect.width > 0 && startRect.height > 0) {
              const targetTop = parseFloat(this.style.getPropertyValue('--qsn-restore-top')) || 0;
              const targetHeight = parseFloat(getComputedStyle(this).getPropertyValue('--qsn-handle-height')) || 22;
              const dx = document.documentElement.clientWidth / 2 - (startRect.left + startRect.width / 2);
              const dy = targetTop + targetHeight / 2 - (startRect.top + startRect.height / 2);
              const sx = 76 / startRect.width;
              const sy = targetHeight / startRect.height;
              const swirlFrame = (offset, progress, rotation, skew, scaleX, scaleY, opacity, blur) => ({
                offset,
                transform: 'translate(' + (dx * progress) + 'px, ' + (dy * progress) + 'px) rotate(' + rotation + 'deg) skewX(' + skew + 'deg) scale(' + scaleX + ', ' + scaleY + ')',
                transformOrigin: '50% 50%',
                opacity,
                filter: 'blur(' + blur + 'px)',
                visibility: 'visible',
                borderRadius: (Math.min(1, progress * 4) * 50) + '%',
                overflow: 'hidden',
                easing: 'linear'
              });
              this.collapseAnimation = this.bar.animate([
                swirlFrame(0, 0, 0, 0, 1, 1, 1, 0),
                swirlFrame(.16, .08, 5, -3, .86, 1.12, 1, .3),
                swirlFrame(.36, .3, 55, 8, .52, 1.04, .95, 1),
                swirlFrame(.58, .62, 190, -10, .23, .74, .85, 1.8),
                swirlFrame(.78, .85, 365, 8, sx * 1.8, sy * 1.4, .7, 2.4),
                swirlFrame(.92, 1, 570, -4, sx * .6, sy * .6, .4, 3),
                swirlFrame(1, 1, 720, 0, sx * .02, sy * .02, 0, 3.5)
              ], { duration: 1150, easing: 'linear' });
            }
            this.restoreButton.focus({ preventScroll: true });
            return;
          }
          if (event.target.closest('.qsn-restore')) {
            this.collapseAnimation?.cancel();
            this.minimized = false;
            this.manuallyExpanded = true;
            this.update();
            this.querySelector('.qsn-minimize').focus({ preventScroll: true });
            return;
          }
          const button = event.target.closest('[data-section-number]');
          if (!button) return;
          const target = this.sections[Number(button.dataset.sectionNumber) - 1];
          if (!target) return;
          const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - Number(this.dataset.topOffset) - this.bar.offsetHeight - Number(this.dataset.scrollGap));
          window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options);
        ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(name => document.addEventListener(name, this.refresh, options));
        ['shopify:section:select', 'shopify:block:select', 'shopify:section:deselect', 'shopify:block:deselect'].forEach(name => {
          document.addEventListener(name, event => {
            if (!this.closest('.shopify-section')?.contains(event.target)) return;
            this.editorSelected = name.endsWith(':select');
            this.schedule();
          }, options);
        });
        this.observer = new ResizeObserver(this.refresh);
        const main = this.closest('main, [role="main"]') || document.querySelector('main, [role="main"], #MainContent');
        if (main) this.observer.observe(main);
        this.refresh();
      }
      update() {
        if (this.minimized) {
          let bottom = 0;
          for (const header of this.headers || []) {
            const rect = header.getBoundingClientRect();
            const style = getComputedStyle(header);
            if (style.visibility !== 'hidden' && Number(style.opacity) !== 0 && rect.width > 0 && rect.height > 0 && rect.top <= 100 && rect.bottom > 0 && rect.bottom < window.innerHeight / 2) bottom = Math.max(bottom, rect.bottom);
          }
          this.style.setProperty('--qsn-restore-top', Math.max(bottom, Number(this.dataset.topOffset) || 0) + 'px');
        }
        const second = this.sections?.[1];
        const passed = second && second.getBoundingClientRect().top <= Number(this.dataset.topOffset);
        const visible = !this.minimized && (this.manuallyExpanded || this.editorSelected || (passed && this.direction === 'down'));
        this.toggleAttribute('data-minimized', Boolean(this.minimized));
        this.restoreButton.hidden = !this.minimized;
        this.toggleAttribute('data-visible', Boolean(visible));
        this.bar.inert = !visible;
        this.bar.setAttribute('aria-hidden', String(!visible));
        const line = Number(this.dataset.topOffset) + this.bar.offsetHeight + Number(this.dataset.scrollGap) + 2;
        let active = null;
        let closestTop = -Infinity;
        this.querySelectorAll('[data-section-number]').forEach(button => {
          button.removeAttribute('aria-current');
          const target = this.sections[Number(button.dataset.sectionNumber) - 1];
          if (!target) return;
          const top = target.getBoundingClientRect().top;
          if (top <= line && top > closestTop) { active = button; closestTop = top; }
        });
        if (active) active.setAttribute('aria-current', 'location');
      }
      disconnectedCallback() {
        this.collapseAnimation?.cancel();
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
